import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import BrandMark from "./BrandMark";

const NAV_LINKS = [
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
  { id: "request", label: "Book Service" },
  { id: "contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  const handleNav = (e, id) => {
    e.preventDefault();
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-black border-b border-slate-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-24 md:h-28 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-3">
          <BrandMark className="h-16 w-16 md:h-20 md:w-20" />
          <div className="leading-none">
            <div className="font-heading font-black text-2xl md:text-3xl tracking-tight uppercase text-white">
              Pneupro
            </div>
            <div className="text-[11px] font-bold tracking-[0.18em] uppercase text-slate-400">
              Air Compressor Services
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              onClick={(e) => handleNav(e, l.id)}
              className="text-sm font-semibold uppercase tracking-wider text-slate-300 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#request"
            onClick={(e) => handleNav(e, "request")}
            data-testid="header-cta-button"
            className="cta-glow bg-blue-600 text-white hover:bg-blue-500 font-bold tracking-wide uppercase px-5 py-2.5 text-xs transition-colors"
          >
            Request Service
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          className="md:hidden p-2 text-white"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-800 bg-black/95">
          <div className="px-6 py-4 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={(e) => handleNav(e, l.id)}
                data-testid={`mobile-nav-link-${l.id}`}
                className="py-3 text-sm font-semibold uppercase tracking-wider text-slate-200 border-b border-slate-800"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
